import './CreateMenu.scss';

import React from 'react';

import Button from 'components/Button';
import CreateMenuLink from './CreateMenuLink';
import CreateMenuLinkSmall from './CreateMenuLinkSmall';

export default class CreateMenu extends React.Component {
    static propTypes = {
        links: React.PropTypes.array.isRequired,
        title: React.PropTypes.string
    };

    constructor() {
        super();

        this.state = {
            showSubmenu: false
        };
    }

    render() {
        let { links, title } = this.props;

        return (
            <section className="create-menu--wrapper">
                <div className="create-menu--small">
                    <CreateMenuLinkSmall onClick={() => this.setState({showSubmenu: !this.state.showSubmenu})} showSubmenu={this.state.showSubmenu} />
                    {this.state.showSubmenu === true ? (
                        <div className="create-menu--small__submenu">
                            {links.map((link, index) => {
                                if(location.pathname.indexOf(link.mobileLinkUrlString) !== -1) {
                                    return (
                                        <Button onClick={() => {
                                            link.onClick();
                                            this.setState({showSubmenu: false});
                                        }}
                                                key={index}>
                                            {link.text}
                                        </Button>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                    ) : null}


                </div>
                <div className="create-menu--large">
                    <header className="create-menu__header">
                        {title || 'Create'}
                    </header>
                    <div className="create-menu__links">
                        {links.map((link, index) => {
                            if(link.showOnDesktop !== false) {
                                return (
                                    <CreateMenuLink icon={link.icon}
                                                    onClick={link.onClick}
                                                    key={index}>
                                        {link.text}
                                    </CreateMenuLink>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateMenu/index.js